// extracted by mini-css-extract-plugin
module.exports = {"text":"Advantageous_text__omUkY","button":"Advantageous_button__yuB1U"};